import { render, staticRenderFns } from "./NodeMenu.vue?vue&type=template&id=db4b4550&scoped=true&"
import script from "./NodeMenu.vue?vue&type=script&lang=js&"
export * from "./NodeMenu.vue?vue&type=script&lang=js&"
import style0 from "./NodeMenu.vue?vue&type=style&index=0&id=db4b4550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4b4550",
  null
  
)

export default component.exports